import angular from 'angular'

import { PayoutPolicyModule } from './policy/payout-policy.module';
import { PayoutPostingModule } from './posting/payout-posting.module';
import { PayoutReportModule } from './report/payout-report.module';
import { PayoutRoutingModule } from './payout-routing.module';

export const PayoutModule = angular
    .module("apex.mainApp.payout", [
        PayoutPolicyModule,
        PayoutPostingModule,
        PayoutReportModule,
        PayoutRoutingModule
    ])
    .name
